import React, { Fragment, MouseEvent, useState } from 'react';

import { FileType } from '../../../types/common.types';

import { isImage } from '../../../utils/util';

import Image from '../image/Image';
import Video from '../video/Video';

import { ReactComponent as ArrowIcon } from '../../../resources/icons/arrow-single.svg';

import './media-carousel.scss';

type Props = {
  mediaFiles: FileType[];
  startIndex: number | undefined;
  setStartIndex: (index: number | undefined) => void;
};

const MediaCarousel = ({ mediaFiles, startIndex, setStartIndex }: Props) => {
  const [currentFile, setCurrentFile] = useState(startIndex);

  if (currentFile === undefined) return <Fragment />;

  const handlePreviousClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();

    if (currentFile === 0) {
      setCurrentFile(mediaFiles.length - 1);
    } else {
      setCurrentFile(currentFile - 1);
    }
  };

  const handleNextClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();

    if (currentFile === mediaFiles.length - 1) {
      setCurrentFile(0);
    } else {
      setCurrentFile(currentFile + 1);
    }
  };

  const mediaFile: FileType | undefined = mediaFiles[currentFile];

  return (
    <div className="media-carousel" onClick={() => setStartIndex(undefined)} data-testid="media-carousel">
      {mediaFiles.length > 1 && (
        <div
          className="media-carousel__action"
          onClick={handlePreviousClick}
          data-testid="media-carousel-previous-button"
        >
          <ArrowIcon />
        </div>
      )}
      <div
        className="media-carousel__content-container"
        onClick={(event: MouseEvent<HTMLDivElement>) => event.stopPropagation()}
      >
        {isImage(mediaFile?.name) ? (
          <Image src={mediaFile?.documentExternalReference ?? (mediaFile as File)} testId={`image-${currentFile}`} />
        ) : (
          <Video src={mediaFile instanceof File ? mediaFile : mediaFile?.link} controls />
        )}
      </div>
      {mediaFiles.length > 1 && (
        <div className="media-carousel__action" onClick={handleNextClick} data-testid="media-carousel-next-button">
          <ArrowIcon />
        </div>
      )}
    </div>
  );
};

export default MediaCarousel;
